import * as yup from 'yup'
import { FormValues } from '.'

export const schema: FormValues = {
  email: '',
  password: ''
}

export const validation = (
  formatMessage: (data: Record<string, string>) => string
) => {
  return (
    yup
      .object()
      .shape({
        email: yup
          .string()
          .email(formatMessage({ id: 'validation.emailValid' }))
          .required(formatMessage({ id: 'validation.emailValid' })),

        password: yup
          .string()
          .required(formatMessage({ id: 'validation.passwordRequired' }))
      })
  )
}
